<template>
  <s-modal
    v-model="showModal"
    size="lg"
    body-class="additional-fields-modal"
    cancel-confirm-message-code="MC006"
    :title="$t('reports.additional-fields')"
    :ok-title="$t('general.confirm')"
    :cancel-title="$t('general.cancel')"
    :confirm-type="confirmationTypes.YES_NO"
    @ok="confirmSelection"
    @cancel="cancel"
  >
    <b-tabs
      class="additional-fields-modal__tabs"
      v-model="activeTab"
    >
      <b-tab
        v-for="tab in filteredTabs"
        :key="tab.name"
        :title="tab.title"
      >
        <component
          class="w-100"
          :is="tab.component"
          :selected-fields.sync="temporaryFields"
        />
      </b-tab>
    </b-tabs>
  </s-modal>
</template>

<script>
import additionalFieldsTabs from '@/domain/data/generalPanel/reports/additionalFields/additionalFieldsTabs';
import confirmationTypes from '@/constants/confirmationTypes';
import { AssetTypes } from 'sigma-mappings';

export default {
  name: 'AdditionalFieldsModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tabsToShow: {
      type: Array,
      default: () => ([
        AssetTypes.TRANSFORMER,
        AssetTypes.CIRCUIT_BREAKER,
        AssetTypes.DISCONNECTOR,
      ]),
    },
  },
  data: vm => ({
    activeTab: 0,
    confirmationTypes,
    tabs: additionalFieldsTabs(vm),
    temporaryFields: ['serialNumber'],
    selectedFields: [],
  }),
  computed: {
    filteredTabs() {
      return this.tabs.filter(tab => this.tabsToShow.includes(tab.name) || tab.name === 'general');
    },
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  created() {
    this.confirmSelection();
  },
  methods: {
    confirmSelection() {
      this.selectedFields = this.temporaryFields;
      this.$emit('confirm', this.selectedFields);
      this.closeModal();
    },
    cancel() {
      this.temporaryFields = this.selectedFields;
      this.closeModal();
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
